import {Component, OnInit} from '@angular/core';

import {Router} from '@angular/router';
import {GalleryModel} from '../../shared/models/galleryModel';
import {GalleriesService} from '../../shared/service/galleries.service';
import {GalleryImageModel} from '../../shared/models/gallery-image.model';


@Component({
  selector: 'app-galleries',
  templateUrl: './galleries.component.html',
  styleUrls: ['./galleries.component.scss']
})
export class GalleriesComponent implements OnInit {

  galleries: GalleryModel[] = [];
  showFlag = false;
  selectedImageIndex = -1;
  galleryImageList: object[] = [];

  constructor(private router: Router, private galleriesService: GalleriesService) {

    this.galleriesService.getGallerys().subscribe((response) => {
      this.galleries = response;
    });


  }

  ngOnInit(): void {
  }

  getGalleryBackGroundImage(item: GalleryModel) {
    return {
      'background-image': 'url(' + item.imageUrl + ')',
    };
  }

  openGallery(item: GalleryModel) {
    this.showFlag = true;
    this.galleryImageList = item.galleryImages.map((galleryImage: GalleryImageModel) => {
      return {
        image: galleryImage.imageUrl,
        thumbImage: galleryImage.imageUrl,
        alt: '',
        title: ''
      };
    });
  }

  closeEventHandler() {
    this.showFlag = false;
    this.selectedImageIndex = -1;
    this.galleryImageList = [];
  }
}
